module.exports = "<div class=\"edit-warning mbm\">{{ t 'webapp.agents.results.result_details.edit_warning' fullname=fullname }}</div>\n"